import { RESTORE_XP_COST } from './constants';

// src/lib/game/lives.ts
const REGEN_MS = 4 * 60 * 60 * 1000; // 4 h

interface DeductLifeArgs {
    lives: number;
    lifeCost?: number;
    minLives?: number;
}

interface RegenArgs {
    lives: number;
    maxLives: number;
    lastRegen: Date | string | null;
    now?: Date;
}

export function deductLife({ lives, lifeCost = 1, minLives = 0 }: DeductLifeArgs): number {
    return Math.max(minLives, lives - lifeCost);
}

export function regenLives({ lives, maxLives, lastRegen, now = new Date() }: RegenArgs): number {
    if (lives >= maxLives) return maxLives;
    if (!lastRegen) return lives;

    const last = typeof lastRegen === 'string' ? new Date(lastRegen) : lastRegen;
    const elapsed = now.getTime() - last.getTime();
    if (elapsed < REGEN_MS) return lives;

    const intervals = Math.floor(elapsed / REGEN_MS);
    const regenerated = Math.min(maxLives, lives + intervals);
    return regenerated;
}

export function canRestoreWithXP(xp: number): boolean {
    return xp >= RESTORE_XP_COST;
}

export function msUntilNextLife(lives: number, maxLives: number, lastRegenAt: string | null): number | null {
    if (lives >= maxLives || !lastRegenAt) return null;
    const next = new Date(lastRegenAt).getTime() + REGEN_MS;
    return Math.max(0, next - Date.now());
}

export function isStreakActive(lastActive: string | null): boolean {
    if (!lastActive) return false;
    const today = new Date().toISOString().slice(0, 10);
    const yesterday = new Date(Date.now() - 86_400_000).toISOString().slice(0, 10);
    return lastActive === today || lastActive === yesterday;
}
